import { HOUR, MINUTE } from '@sparelabs/time'

export class FlagDownConstants {
  public static FLAG_DOWN_PICKUP_FLEXIBILITY = MINUTE

  public static FLAG_DOWN_PRE_MATCH_TRAVEL_DURATION_FLEXIBILITY = 24 * HOUR

  public static FLAG_DOWN_POST_MATCH_TRAVEL_DURATION_FLEXIBILITY = 10 * MINUTE
}
